import { createReducer, createFeature, on } from '@ngrx/store';

import { Owner } from '../../../objects/owner';
import { ServiceArea } from '../../../objects/service-area';
import { OwnerActions } from '../actions';
import { Storefront } from '../storefront.service';
import { DestinationSelectSetting } from '../../../objects/destination-select-setting';


export interface State {
  owner: Owner | null;
  serviceAreas: ServiceArea[] | null;
  storefront: Storefront | null;
  error: Error | null;
  storefrontError: Error | null;
  destinationSelectSetting: DestinationSelectSetting;
}

export const initialState: State = {
  owner: null,
  serviceAreas: null,
  storefront: null,
  error: null,
  storefrontError: null,
  destinationSelectSetting: DestinationSelectSetting.both,
};

export const ownerFeature = createFeature({
  name: 'owner',
  reducer: createReducer(
    initialState,
    on(OwnerActions.loadOwner, state => ({ ...state, owner: null, error: null })),
    on(OwnerActions.loadOwnerSuccess, (state, { owner }) => ({ ...state, owner, error: null })),
    on(OwnerActions.loadOwnerFailure, (state, { error }) => ({ ...state, owner: null, error })),

    on(OwnerActions.loadServiceAreas, state => ({ ...state, serviceAreas: null, error: null })),
    on(OwnerActions.loadServiceAreasSuccess, (state, { serviceAreas }) => ({ ...state, serviceAreas, error: null })),
    on(OwnerActions.loadServiceAreasFailure, (state, { error }) => ({ ...state, serviceAreas: null, error })),

    on(OwnerActions.loadStorefronts, state => ({ ...state, storefronts: null, storefrontError: null })),
    on(OwnerActions.loadStorefrontSuccess, (state, { storefront }) => ({ ...state, storefront, storefrontError: null })),
    on(OwnerActions.loadStorefrontFailure, (state, { error }) => ({ ...state, storefronts: null, storefrontError: error })),

    on(OwnerActions.setDestinationSelectSetting, (state, { destinationSelectSetting }) => ({ ...state, destinationSelectSetting })),
  ),
});

export const {
  name: ownerFeatureKey,
  reducer,
  selectOwnerState,
  selectOwner,
  selectServiceAreas,
  selectError: selectOwnerError,
  selectStorefront,
  selectStorefrontError,
  selectDestinationSelectSetting,
} = ownerFeature;
